import { create } from 'zustand';

export const useBcpStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    uniqueValues: {},

    // [CRITICAL] Standard Pagination Shape
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setPagination: (pagination) => set((state) => ({
        pagination: { ...state.pagination, ...pagination }
    })),

    // Compatibility setters
    setData: (items) => set({ items }),
    setBcps: (items) => set({ items }),
    setStats: (stats) => set({ stats }),

    // UI Helpers
    isFormOpen: false,
    selectedItem: null,
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setSelectedBcp: (selectedItem) => set({ selectedItem }),
    setCurrentBcp: (selectedItem) => set({ selectedItem }),
    openForm: (item = null) => set({ isFormOpen: true, selectedItem: item }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null }),

    clearError: () => set({ error: null }),
}));
